export const rootPaths = {
  errorsRoot: 'errors',
  adminRoot: 'management',
};

export default {
  login: '/login',
  myPage: 'mypage',

  passwordReset: '/password-reset',
  confirmMail: '/confirm-mail',
  passwordResetConfirm: '/password-reset/confirm/',

  // Products
  products: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/products`,
    manage: (tenant, warehouse) =>
      `/${tenant}/${warehouse}/products/manage-product`,
    details: (tenant, warehouse, productId) =>
      `/${tenant}/${warehouse}/products/manage-product${
        productId ? `/${productId}` : ''
      }`,
  },

  // Purchase Orders
  purchaseOrder: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/purchase-orders`,
    create: (tenant, warehouse) =>
      `/${tenant}/${warehouse}/purchase-orders/create`,
    details: (tenant, warehouse, purchaseOrderId) =>
      `/${tenant}/${warehouse}/purchase-orders${
        purchaseOrderId ? `/${purchaseOrderId}` : ''
      }`,
  },

  // Vendors
  vendors: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/vendors`,
    create: (tenant, warehouse) => `/${tenant}/${warehouse}/vendors/create`,
    details: (tenant, warehouse, vendorId) =>
      `/${tenant}/${warehouse}/vendors${vendorId ? `/${vendorId}` : ''}`,
  },

  // GRNs
  grns: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/purchase-orders/grns`,
    details: (tenant, warehouse, grnId) =>
      `/${tenant}/${warehouse}/purchase-orders/grns${grnId ? `/${grnId}` : ''}`,
  },

  // PutAway
  putAway: {
    list: (tenant, warehouse) =>
      `/${tenant}/${warehouse}/purchase-orders/put-away`,
    create: (tenant, warehouse) =>
      `/${tenant}/${warehouse}/purchase-orders/put-away/create`,
    details: (tenant, warehouse, putawayId) =>
      `/${tenant}/${warehouse}/purchase-orders/put-away${
        putawayId ? `/${putawayId}` : ''
      }`,
  },

  // Orders
  orders: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/orders`,
    details: (tenant, warehouse, orderId) =>
      `/${tenant}/${warehouse}/orders${orderId ? `/${orderId}` : ''}`,
  },

  // Shipments
  shipments: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/shipments`,
  },

  // Picklists
  picklists: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/picklists`,
    create: (tenant, warehouse) => `/${tenant}/${warehouse}/picklists/create`,
    details: (tenant, warehouse, picklistId) =>
      `/${tenant}/${warehouse}/picklists${picklistId ? `/${picklistId}` : ''}`,
    process: (tenant, warehouse, picklistId) =>
      `/${tenant}/${warehouse}/picklists/process${
        picklistId ? `/${picklistId}` : ''
      }`,
  },

  // Manifests
  manifests: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/manifests`,
    details: (tenant, warehouse, manifestId) =>
      `/${tenant}/${warehouse}/manifests${manifestId ? `/${manifestId}` : ''}`,
  },

  // Inventory
  inventory: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/inventory`,
    history: (tenant, warehouse) => `/${tenant}/${warehouse}/inventory/history`,
  },

  // Returns
  returns: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/return-manifests`,
    details: (tenant, warehouse, returnManifestId) =>
      `/${tenant}/${warehouse}/return-manifests${
        returnManifestId ? `/${returnManifestId}` : ''
      }`,
  },

  // Stocktaking
  stocktakings: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/stocktakings`,
    details: (tenant, warehouse, stocktakingId) =>
      `/${tenant}/${warehouse}/stocktakings${
        stocktakingId ? `/${stocktakingId}` : ''
      }`,
  },

  // Gate Passes
  gatePasses: {
    list: (tenant, warehouse) => `/${tenant}/${warehouse}/gate-passes`,
    receivedList: (tenant, warehouse) =>
      `/${tenant}/${warehouse}/gate-passes/received-list`,
    details: (tenant, warehouse, gatePassId) =>
      `/${tenant}/${warehouse}/gate-passes${
        gatePassId ? `/${gatePassId}` : ''
      }`,
  },

  // Bulk Actions
  bulkAction: (tenant, warehouse, query) =>
    `/${tenant}/${warehouse}/bulk-action?type=${query}`,

  // Admin
  user: (tenant, warehouse) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/user`,
  userDetails: (tenant, warehouse, userId) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/user${
      userId ? `/${userId}` : ''
    }`,
  shelf: `/${rootPaths.adminRoot}/shelf`,
  shelfDetails: (tenant, warehouse, shelfId) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/shelf${
      shelfId ? `/${shelfId}` : ''
    }`,
  warehouse: (tenant, warehouse) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/warehouse`,
  warehouseDetails: (tenant, warehouse, warehouseId) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/warehouse/detail/${warehouseId}`,
  sequence: (tenant, warehouse) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/sequence`,
  shippingProvider: (tenant, warehouse) =>
    `/${tenant}/${warehouse}/${rootPaths.adminRoot}/shipping-provider`,

  // Errors
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,
};
